var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"fill-height",attrs:{"no-gutters":""}},[_c('crud-table',{attrs:{"service":_vm.service,"customFunctions":_vm.customFunctions,"crudDialog":_vm.crudDialog,"editCustomView":_vm.editCustomView}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }